module.exports = __webpack_public_path__ + "img/help-question.4958b291.svg";